import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './NetworkAuth.css';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.alooma.mg';

function ResetPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!token) {
      setError('This reset link is invalid or missing a token.');
      return;
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    setIsLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'Failed to reset password');
      setSuccess(data.message || 'Password reset successfully.');
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="network-auth-page">
      <div className="auth-bg">
        <div className="auth-gradient"></div>
        <div className="auth-particles"></div>
      </div>

      <div className="auth-container">
        <div className="auth-header">
          <img src="/network-logo.png" alt="Alooma Network" className="network-auth-logo" />
          <h1 className="auth-title">
            Reset <span className="accent">Password</span>
          </h1>
          <p className="auth-subtitle">Choose a new password for your account</p>
        </div>

        {success ? (
          <div className="auth-form">
            <div className="forgot-success">
              <p>{success}</p>
              <button type="button" className="submit-btn" onClick={() => navigate('/network')}>
                Go to Sign In
              </button>
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="auth-form">
            {error && <div className="error-message">{error}</div>}

            <div className="form-group">
              <label htmlFor="password">New Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={6}
                placeholder="••••••••"
              />
            </div>

            <div className="form-group">
              <label htmlFor="confirmPassword">Confirm New Password</label>
              <input
                type="password"
                id="confirmPassword"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                placeholder="••••••••"
              />
            </div>

            <button type="submit" className="submit-btn" disabled={isLoading}>
              {isLoading ? 'Resetting...' : 'Reset Password'}
            </button>
          </form>
        )}

        <div className="back-link">
          <a href="/network">← Back to Sign In</a>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
